import { render, staticRenderFns } from "./MaterialDirectory.vue?vue&type=template&id=c054ffbe&scoped=true&"
import script from "./MaterialDirectory.vue?vue&type=script&lang=js&"
export * from "./MaterialDirectory.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDirectory.vue?vue&type=style&index=0&id=c054ffbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c054ffbe",
  null
  
)

export default component.exports